export default __webpack_public_path__ + "static/media/modal-close-icon.4069ae41.svg";